<template>
  <div class="relative min-h-screen f-col">
    <vf-button
      v-if="mainContent"
      class="absolute left-0 top-0 z-toast ml-4"
      data-test-id="skip-to-main-content"
      size="tiny"
      :style="{ 'margin-top': showSkipLink ? '0.25rem' : '-100%' }"
      to="#main-content"
      variant="primary-inverse"
      @blur="showSkipLink = false"
      @click="mainContent.focus()"
      @focus="showSkipLink = true"
    >
      {{ $t.skipToMainContent }}
    </vf-button>

    <suspense v-if="!hideHeader">
      <vf-header-provider :hidden="!!route.meta.hideLayout" />
    </suspense>

    <div
      ref="mainContent"
      id="main-content"
      class="relative w-0"
      :contenteditable="!!isIOS"
      style="top: -5rem; margin-top: -1px"
      tabindex="-1"
    />

    <slot />

    <base-lazy-hydrate v-if="!route.meta.hideLayout && !route.meta.hideFooter" when="visible">
      <vf-footer
        ref="footerRef"
        class="mt-a"
        :hide-newsletter="!$feature.newsletterFormDynamic && (auth.loggedIn || auth.pending)"
      />
    </base-lazy-hydrate>

    <chat-launcher v-if="$chat.launcher" />
  </div>
</template>

<script lang="ts" setup>
import { isIOS } from '@vueuse/core'

const { $feature, $viewport } = useNuxtApp()
const footerRef = useState<HTMLElement>('footerRef')
const route = useRoute()
const loyalty = useLoyaltyStore()
const toast = useToaster()
const auth = useAuthStore()
const config = useAppConfig()
const loyaltyConfig = config.components.vf.loyalty
const { getLoyaltyMessages, isLoyaltyToastNeeded } = useLoyalty()
const mainContent = ref<HTMLDivElement>()
const showSkipLink = ref(false)
const hideHeader = computed(() => (config.pages.plp.useCustomHeader && route.path.includes('/c/')))
const isLoyaltyToastAlreadyDisplayed = useSessionStorage('isLoyaltyToastAlreadyDisplayed', false)
const displayLoyaltyToast = () => {
  if (!$feature.showLoyaltyRewardsInUtilityNav || !isLoyaltyToastNeeded() || $viewport.lg) return

  const loyaltyMessages = computed(() => getLoyaltyMessages())

  toast.add({
    props: {
      type: '',
      variant: 'loyalty',
      classToast: loyaltyConfig.brandClasses.rewardsPreviewTilePopoverContent,
      classMessage: loyaltyConfig.brandClasses.rewardsPreviewTilePopoverContentInner,
      title: loyaltyMessages.value.rewardsGreeting,
      message: loyaltyMessages.value.title,
      bottomText: loyaltyMessages.value.text,
      icon: { src: loyaltyConfig.logo, size: 'xl' }
    }
  })
  isLoyaltyToastAlreadyDisplayed.value = true
}

watch (() => loyalty.rewardsAvailable, () => {
  if (loyalty.rewardsAvailable?.length && !isLoyaltyToastAlreadyDisplayed.value) displayLoyaltyToast()
})
</script>
